import { useEffect } from "react";
import {
  criticalAttributesImpactedOptions,
  trueFalseDropdownOptions,
  gpdsMilestoneOptions,
} from "../../../utilities/dropDownOptions";
import { 
   getItemByValueInDropdownOptions,
   getItemsByValuesInDropdownOptions,
} from "../../../utilities/utilityFunctions";
import { textHints } from "../../../utilities/hintText";
import { validateModuleInformationValue } from "../../../utilities/formValidation";
import { SelectField } from "../formFields/SelectField";
import { useDataContext } from "../../DataProvider/DataContext";
import { checkIfFieldIsRequiredPerArchitecture } from "../../../utilities/architectureTypeDataProcess";
import { FlexColumnDiv, FlexRowDiv, StepperContentBodyDiv, StepperContentHeaderDiv } from "../../styledComponents/Components.styles";
import LabelField from "../formFields/LabelField";
import { adjustSelectionCriteriaBasedOnVehiclePrograms } from "../../../utilities/selectionCriteriaUtils";


const ModuleInformation = ({
  moduleInformation, 
  setModuleInformation,
  moduleInformationErrors,
  setModuleInformationErrors,
  setModuleName,
  setMachineList,
  setMachineListErrors,
}) => {

    const {ECUData, dynamicSelectOptionsMap, architectureType} = useDataContext();
    const handleModuleInformationMainSelectChange = (selectedOptions, fieldName, isRequired) => {
        const newModuleInformationValues = structuredClone(moduleInformation);
    
        let values;
        if (Array.isArray(selectedOptions)) {
          values = selectedOptions.map(option => option.value);
        } else {
          values = selectedOptions?.value;
        }
        newModuleInformationValues[fieldName] = values;

        setModuleInformation(newModuleInformationValues);
      
        // Validate if required
        if (isRequired) {
          validateModuleInformationValue(fieldName, values, setModuleInformationErrors);
        }
  
    };

    const handleVehicleProgramsChange = (selectedOptions) => {
        const newModuleInformationValues = structuredClone(moduleInformation);
        const values = selectedOptions.map(option => option.value);
        newModuleInformationValues["vehiclePrograms"] = values;
        setModuleInformation(newModuleInformationValues);
        validateModuleInformationValue("vehiclePrograms", values, setModuleInformationErrors);
        adjustSelectionCriteriaBasedOnVehiclePrograms(setMachineList, values, setMachineListErrors);
    }

    useEffect(() => {
        setModuleName(moduleInformation.moduleName);
    }
    , [moduleInformation.moduleName]);

    return(
        <FlexColumnDiv style={{marginLeft: '40px', marginBottom: '20px'}}>
          <StepperContentHeaderDiv style={{paddingTop: '10px', paddingBottom: '10px', marginBottom: '20px'}}>
            <FlexColumnDiv style={{gap: '10px'}}>
              <LabelField
                label="Module Name"
                value={moduleInformation.moduleName}
              />
              <LabelField
                label="Module Description"
                value={ECUData.current.moduleData?.moduleDescription ?? "N/A"}
              />
            </FlexColumnDiv>
          </StepperContentHeaderDiv>

          <StepperContentBodyDiv style={{width: '1240px', alignSelf: 'center', marginBottom: '20px', alignItems: 'center', flexDirection: 'column'}}>
                  <FlexRowDiv style={{gap: '36px'}}>
                    <SelectField
                      label="GPDS Milestone"
                      value={getItemByValueInDropdownOptions(gpdsMilestoneOptions, moduleInformation.gpdsMilestone)}
                      options={gpdsMilestoneOptions}
                      placeholder="--Please Select--"
                      onChange={(selectedOptions) => handleModuleInformationMainSelectChange(selectedOptions, "gpdsMilestone", checkIfFieldIsRequiredPerArchitecture("moduleInformation.gpdsMilestone", architectureType))}
                      onRevert={() => {
                        setModuleInformation((prev) => {
                          return {
                            ...prev,
                            gpdsMilestone: ECUData.current.prefilledJSONContent.moduleInformation.gpdsMilestone,
                          };
                        })
                        if (checkIfFieldIsRequiredPerArchitecture("moduleInformation.gpdsMilestone", architectureType)) {
                          validateModuleInformationValue("gpdsMilestone", ECUData.current.prefilledJSONContent.moduleInformation.gpdsMilestone, setModuleInformationErrors);
                        }
                      }}
                      textHint={textHints.gpdsMilestone}
                      errorMessage={moduleInformationErrors.gpdsMilestoneValidationError}
                      isLoading={false}
                      isMulti={false}
                      idInput="gpdsMilestone"
                      idError="gpdsMilestone_error"
                      nameInput="gpdsMilestone"
                      isPrefilledValueChanged={moduleInformation.gpdsMilestone !== ECUData.current.prefilledJSONContent.moduleInformation.gpdsMilestone}
                      required={checkIfFieldIsRequiredPerArchitecture("moduleInformation.gpdsMilestone", architectureType)}
                      pathToField="moduleInformation.gpdsMilestone"
                      stylingVariant="body"
                    />
                    <SelectField
                        label="Public Road Worthy"
                        value={getItemByValueInDropdownOptions( trueFalseDropdownOptions, moduleInformation.publicRoadWorthy )}
                        options={trueFalseDropdownOptions}
                        placeholder="--Please Select--"
                        onChange={(selectedOptions) => handleModuleInformationMainSelectChange( selectedOptions, "publicRoadWorthy", checkIfFieldIsRequiredPerArchitecture("moduleInformation.publicRoadWorthy", architectureType))}
                        textHint={textHints.publicRoadWorthy}
                        errorMessage={moduleInformationErrors.publicRoadWorthyValidationError}
                        isLoading={false}
                        isMulti={false}
                        idInput="publicRoadWorthy"
                        idError="publicRoadWorthy_error"
                        nameInput="publicRoadWorthy"
                        required={checkIfFieldIsRequiredPerArchitecture("moduleInformation.publicRoadWorthy", architectureType)}
                        pathToField="moduleInformation.publicRoadWorthy"
                        stylingVariant="body"
                    />
                  </FlexRowDiv>

                  <FlexRowDiv style={{gap: '36px'}}>
                    <SelectField
                        label="Vehicle Program"
                        isMulti={true}
                        value={getItemsByValuesInDropdownOptions(
                            dynamicSelectOptionsMap.vehiclePrograms ?? [],
                            moduleInformation.vehiclePrograms
                        )}
                        options={dynamicSelectOptionsMap.vehiclePrograms ?? []}
                        placeholder="--Please Select--"
                        onChange={handleVehicleProgramsChange}
                        onRevert={() => {
                          setModuleInformation((prev) => {
                            return {
                              ...prev,
                              vehiclePrograms: ECUData.current.prefilledJSONContent.moduleInformation.vehiclePrograms,
                            };
                          })

                          if (checkIfFieldIsRequiredPerArchitecture("moduleInformation.vehiclePrograms", architectureType)) {
                            validateModuleInformationValue("vehiclePrograms", ECUData.current.prefilledJSONContent.moduleInformation.vehiclePrograms, setModuleInformationErrors);
                          }
                          
                        }}
                        textHint={textHints.vehiclePrograms}
                        errorMessage={moduleInformationErrors.vehicleProgramsValidationError}
                        isLoading={false}
                        idInput="vehiclePrograms"
                        idError="vehicleProgram_error"
                        nameInput="vehiclePrograms"
                        isPrefilledValueChanged={JSON.stringify(moduleInformation.vehiclePrograms) !== JSON.stringify(ECUData.current.prefilledJSONContent.moduleInformation.vehiclePrograms)}
                        required={checkIfFieldIsRequiredPerArchitecture("moduleInformation.vehiclePrograms", architectureType)}
                        pathToField="moduleInformation.vehiclePrograms"
                        stylingVariant="body"
                    />
                    <SelectField
                      required={checkIfFieldIsRequiredPerArchitecture("moduleInformation.criticalAttributesImpacted", architectureType)}
                        label="Critical Attributes"
                        value={getItemsByValuesInDropdownOptions( criticalAttributesImpactedOptions, moduleInformation.criticalAttributesImpacted )}
                        options={criticalAttributesImpactedOptions}
                        placeholder="--Please Select--"
                        onChange={(selectedOptions) => {
                            const selectedValues = selectedOptions.map(option => option.value);
                            if (selectedValues.length === 0) {
                                selectedValues.push("NOT_APPLICABLE");
                            } else if (selectedValues.length > 1 && selectedValues.includes("NOT_APPLICABLE")) {
                                selectedValues.splice(selectedValues.indexOf("NOT_APPLICABLE"), 1);
                            }

                            setModuleInformation((prev) => {
                                return {
                                    ...prev,
                                    criticalAttributesImpacted: selectedValues,
                                };
                            }
                            );
                            validateModuleInformationValue("criticalAttributesImpacted", selectedValues, setModuleInformationErrors);
                            
                        }}
                        textHint={textHints.criticalAttributesImpacted}
                        errorMessage={moduleInformationErrors.criticalAttributesImpactedValidationError}
                        isLoading={false}
                        isMulti={true}
                        idInput="criticalAttributesImpacted"
                        idError="criticalAttributesImpacted_error"
                        nameInput="criticalAttributesImpacted"
                        pathToField="moduleInformation.criticalAttributesImpacted"
                        stylingVariant="body"
                    />
                  </FlexRowDiv>

                  <FlexRowDiv style={{gap: '36px'}}>
                    <SelectField
                        label="LVEAs"
                        value={getItemsByValuesInDropdownOptions( dynamicSelectOptionsMap.lveas ?? [], moduleInformation.lveas )}
                        options={dynamicSelectOptionsMap.lveas ?? []}
                        placeholder="--Please Select--"
                        onChange={(selectedOptions) => handleModuleInformationMainSelectChange(selectedOptions, "lveas", checkIfFieldIsRequiredPerArchitecture("moduleInformation.lveas", architectureType))}
                        onRevert={() => {
                          setModuleInformation((prev) => {
                            return {
                              ...prev,
                              lveas: ECUData.current.prefilledJSONContent.moduleInformation.lveas,
                            };
                          })
                          if (checkIfFieldIsRequiredPerArchitecture("moduleInformation.lveas", architectureType)) {
                            validateModuleInformationValue("lveas", ECUData.current.prefilledJSONContent.moduleInformation.lveas, setModuleInformationErrors);
                          }
                        }}
                        textHint={textHints.lveas}
                        errorMessage={moduleInformationErrors.lveasValidationError}
                        isLoading={false}
                        isMulti={true}
                        idInput="lveas"
                        idError="lveas_error"
                        nameInput="lveas"
                        isPrefilledValueChanged={JSON.stringify(moduleInformation.lveas) !== JSON.stringify(ECUData.current.prefilledJSONContent.moduleInformation.lveas)}
                        required={checkIfFieldIsRequiredPerArchitecture("moduleInformation.lveas", architectureType)}
                        pathToField="moduleInformation.lveas"
                        stylingVariant="body"
                    />
                    <SelectField
                        label="CMA Enabled"
                        value={getItemByValueInDropdownOptions( trueFalseDropdownOptions, moduleInformation.cmaEnabled )}
                        options={trueFalseDropdownOptions}
                        placeholder="--Please Select--"
                        onChange={(selectedOptions) => handleModuleInformationMainSelectChange(selectedOptions, "cmaEnabled", checkIfFieldIsRequiredPerArchitecture("moduleInformation.cmaEnabled", architectureType))}
                        textHint={textHints.cmaEnabled}
                        errorMessage={moduleInformationErrors.cmaEnabledValidationError}
                        isLoading={false}
                        isMulti={false}
                        idInput="cmaEnabled"
                        idError="cmaEnabled_error"
                        nameInput="cmaEnabled"
                        isPrefilledValueChanged={moduleInformation.cmaEnabled !== ECUData.current.prefilledJSONContent.moduleInformation.cmaEnabled}
                        required={checkIfFieldIsRequiredPerArchitecture("moduleInformation.cmaEnabled", architectureType)}
                        pathToField="moduleInformation.cmaEnabled"
                        stylingVariant="body"
                    />
                  </FlexRowDiv>
                
          </StepperContentBodyDiv>     
        </FlexColumnDiv>
    );
}

export default ModuleInformation;